import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { navigationItems, NavigationItem } from './constants'

interface NavigationSidebarProps {
	activeSection: string
	onSectionClick: (sectionId: string) => void
}

export const NavigationSidebar = ({ activeSection, onSectionClick }: NavigationSidebarProps) => (
	<aside className="hidden lg:block w-64 flex-shrink-0 py-12 pr-8">
		<div className="sticky top-12 h-auto max-h-[calc(100vh-6rem)] overflow-y-auto">
			<Link
				to="/dashboard"
				className="inline-flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition-colors mb-6 group">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 20 20"
					fill="currentColor"
					className="w-4 h-4 mr-2 transform group-hover:-translate-x-1 transition-transform">
					<path
						fillRule="evenodd"
						d="M15 10a.75.75 0 01-.75.75H7.612l2.158 1.96a.75.75 0 11-1.04 1.08l-3.5-3.25a.75.75 0 010-1.08l3.5-3.25a.75.75 0 111.04 1.08L7.612 9.25h6.638A.75.75 0 0115 10z"
						clipRule="evenodd"
					/>
				</svg>
				Back to Dashboard
			</Link>
			<h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
				Installation Guide
			</h2>
			<nav className="space-y-1">
				{navigationItems.map((item) => (
					<button
						key={item.id}
						onClick={() => onSectionClick(item.id)}
						className={cn(
							'w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-2',
							activeSection === item.id
								? 'bg-primary/10 text-primary dark:bg-primary/20'
								: 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800'
						)}>
						{item.icon}
						{item.title}
					</button>
				))}
			</nav>
		</div>
	</aside>
)